// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ utils
const { FormattedText } = require('core/i18n').i18n;

// @components
const PassContainer = require('components/contactCenter/passContainer/passContainer');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

require('./KeysCCStep1.scss');

class KeysCCStep1 extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        const {documentNumer, documentType , mobileNumber, titleStep } = this.props;
        // @copies
        const title = titleStep;
        const confirmId = <FormattedText value="keysCCStep1-confirmIdNote" />;
        const confirmMobile = <FormattedText value="keysCCStep1-confirmMobileNote" />;
        const idTypeLabel = <FormattedText value="keysCCStep1-typeIdLabel" />;
        const idNumberLabel = <FormattedText value="keysCCStep1-idNumberLabel" />;
        const mobileNumberLabel = <FormattedText value="keysCCStep1-mobileNumberLabel" />;
        const message =  <FormattedText value="keysCCStep1-message" />;
        const numerDocument = documentNumer;

        return (
            <PassContainer title={title} >
                <div className="keys-cc-step1">
                    <div className="keys-cc-step1__row-info no-print-out">
                        <BlockInfo extraClass="keys-cc-step1__medium-box">
                            {confirmId}
                        </BlockInfo>
                        <div className="keys-cc-step1__separator"/>
                        <BlockInfo extraClass="keys-cc-step1__medium-box">
                            {confirmMobile}
                        </BlockInfo>
                    </div>
                    <div className="keys-cc-step1__row-info">
                        <div className="keys-cc-step1__medium-box">
                            <div className="keys-cc-step1__document-type">
                                <p className="keys-cc-step1__label-primary-info">{idTypeLabel}</p>
                                <p className="keys-cc-step1__primary-info">{documentType}</p>
                            </div>
                            <div>
                                <p className="keys-cc-step1__label-primary-info">{idNumberLabel}</p>
                                <p className="keys-cc-step1__primary-info">{numerDocument}</p>
                            </div>
                        </div>
                        <div className="keys-cc-step1__medium-box">
                            <div className="keys-cc-step1__movil-number">
                                <p className="keys-cc-step1__label-primary-info">{mobileNumberLabel}</p>
                                <p className="keys-cc-step1__primary-info">{mobileNumber}</p>
                            </div>
                        </div>
                    </div>
                    <div className="keys-cc-step1__row-info no-print-out">
                        <BlockInfo>
                            {message}
                        </BlockInfo>
                    </div>
                </div>
            </PassContainer>
        );
    }
}

KeysCCStep1.propTypes = {
    documentNumer: PropTypes.string,
    documentType: PropTypes.string,
    mobileNumber: PropTypes.string,
    currentStep : PropTypes.number.isRequired,
    isFetchingUserData : PropTypes.bool,
    isFetching: PropTypes.bool.isRequired,
    hasBeenSent: PropTypes.bool.isRequired,
    requestCodeOTP: PropTypes.func.isRequired,
    fields: PropTypes.object,
    titleStep : PropTypes.string.isRequired,
    isDisaster : PropTypes.bool,
};

KeysCCStep1.defaultProps = {
    isDisaster: false,
}

module.exports = KeysCCStep1;
